import React from 'react';
import { Field } from 'redux-form';
import { SelectArrayInput, TextInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import PropertyGroupVisibilities from '../../../../StaticData/PropertyGroupVisibilities';

const styles = createStyles({
  fields: {
    width: '90%'
  }
});

type Props = {
  classes: any,
  record: any
}

const SettingsTab = (props: Props) => (
  <div>
    <div style={{ display: 'flex', width: '90%' }}>
      <div style={{ flex: '1' }}>
        <Field name="name" source="name" label="Name" component={TextInput} className={props.classes.fields} /><br />
      </div>
      <div style={{ flex: '1' }}>
        {(props.record && props.record.value) ? <div style={{ paddingTop: 20 }}><span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '.8rem' }}>Value</span><br />{props.record.value}</div> :
          <Field name="value" source="value" label="Value" component={TextInput} className={props.classes.fields} />
        }<br />
      </div>
    </div>

    <Field name="visibilities" source="visibilities" component={SelectArrayInput} label="Visibility" choices={PropertyGroupVisibilities} className={props.classes.fields} /><br />
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Managed/PropertyGroups/Partials/SettingsTab.tsx